import { ChiroUpAPI } from '@chiroup/client-core/functions/ChiroUpAPI';
import { ListClinic } from '@chiroup/core/types/Clinic.type';

const clinicService = () => {
  const list = async (params: { search?: string; limit?: number; skip?: number }) => {
    return ChiroUpAPI.get('api', `/clinics`, {
      queryParams: params,
    });
  };

  const findOne = async (ID?: string): Promise<ListClinic> => {
    const res = await ChiroUpAPI.get('api', `/clinics/${ID}`, {});

    return res || {};
  };

  const update = async (clinic: Partial<ListClinic>) => {
    const { ID, ...restOfClinic } = clinic;
    const res = await ChiroUpAPI.put('api', `/clinics/${ID}`, {
      body: restOfClinic,
    });

    return res || {};
  };

  const del = (clinicID: string) => {
    return ChiroUpAPI.del('api', `/clinic/${clinicID}`, {});
  };

  const create = async (val: Partial<ListClinic>) => {
    const res = await ChiroUpAPI.post('api', `/clinics`, {
      body: val,
    });

    return res || {};
  };

  const listIntegrations = async (clinicId: number) => {
    return ChiroUpAPI.get('api', `/clinic/${clinicId}/integrations`, {});
  };

  const activeIntegration = async (clinicId: number, integrationId: number, active: boolean) => {
    return ChiroUpAPI.put('api', `/clinic/${clinicId}/integration/${integrationId}/activate`, {
      body: { active },
    });
  };

  const listIcons = async () => {
    const res = await ChiroUpAPI.get('api', `/icons`, {});

    return res;
  };

  const teardownMessaging = async (clinicId: number) => {
    return ChiroUpAPI.post('api', `/clinic/${clinicId}/teardown-messaging`, {});
  };

  return {
    list,
    findOne,
    update,
    del,
    create,
    listIcons,
    listIntegrations,
    activeIntegration,
    teardownMessaging,
  };
};

export default clinicService();
